import { UserForTracking } from '../graphql/queries/user.queries'

interface Intercom {
  (method: 'boot', settings: object): void;
  (method: 'update', settings: object): void;
  (method: 'show'): void;
  (method: 'hide'): void;
}

const intercom = <Intercom>window['Intercom']

function updateIntercomSettings(user: UserForTracking): void {
  if (intercom) {
    intercom('update', user.intercomAttributes)
  }
}


export { updateIntercomSettings }
